import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import ModuleMenuLateral from '@/store/interface/ModuleMenuLateral.js';
import ModuleAlertas from '@/store/interface/ModuleAlertas.js';
import ModuleNotasFiscais from '@/store/notas/ModuleNotasFiscais.js';
import ModuleSimulacao from '@/store/simulacao/ModuleSimulacao.js';
import ModulePropostas from '@/store/simulacao/ModulePropostas.js';
import ModuleCombateFraude from '@/store/simulacao/ModuleCombateFraude.js';
import ModuleClientes from '@/store/simulacao/ModuleClientes.js';
import ModuleSituacoesProposta from '@/store/simulacao/ModuleSituacoesProposta.js';
import ModuleUsuario from '@/store/simulacao/ModuleUsuario.js';
import ModuleLocalizacao from '@/store/simulacao/ModuleLocalizacao.js';
import ModuleEmpresa from '@/store/simulacao/ModuleEmpresa.js';
import ModuleCnh from '@/store/simulacao/ModuleCnh.js';
import ModuleCbo from '@/store/simulacao/ModuleCbo.js';
import ModuleConsultaSaldo from '@/store/consultaSaldo/ModuleConsultaSaldo.js';
import ModuleConfig from '@/store/interface/ModuleConfig.js';

export default new Vuex.Store({
  modules: {
    ModuleMenuLateral,
    ModuleSimulacao,
    ModulePropostas,
    ModuleCombateFraude,
    ModuleClientes,
    ModuleSituacoesProposta,
    ModuleUsuario,
    ModuleAlertas,
    ModuleLocalizacao,
    ModuleEmpresa,
    ModuleNotasFiscais,
    ModuleCnh,
    ModuleCbo,
    ModuleConsultaSaldo,
    ModuleConfig,
  },
});
